import { Button, Divider, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { HEADER_DATA_UPDATE } from "../../../redux/reducers/header.reducer";
import { useLoading } from "../../../components/Loading/useLoading";
import { GetAllDefectivos } from "../../../hooks/defectivos";
import { TablaDefectivos } from "./tablaDefectivos";
import { ModalDefectivo } from "./modalDefectivos";

export const DefectivosIndex = () => {


  const dispatch = useDispatch();
  const { setAppLoading } = useLoading();
  const { getAllDefectivosMutation } = GetAllDefectivos();
  const [openNuevo, setOpenNuevo] = useState(false);
  const [defectivos, setDefectivos] = useState([]);

  const get_data_tabla = () => {
    setAppLoading(true);
    getAllDefectivosMutation({}, {
      onSuccess: (data) => {
        setDefectivos(data);
        setAppLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setAppLoading(false);
      },
    })
  }

  useEffect(() => {
    dispatch(
      HEADER_DATA_UPDATE({ nombreData: null })
    )
  }, []);
  useEffect(() => {
    get_data_tabla();
  }, [openNuevo]);
  


  return (
    <>
      <Grid container spacing={0} sx={{ height: '10vh' }}>
        <Grid item xs={3} sm={3} md={3} lg={2} xl={2} sx={{ padding: '10px 30px', height: '100%' }} className="center_item">
          <Button
            variant="contained"
            className="btn_system"
            onClick={() => setOpenNuevo(true)}>
            Crear
          </Button>
        </Grid>
      </Grid>
      <Divider />
      <Grid container spacing={0} sx={{ height: '70vh' }}>
        <Grid item xs={12} sx={{ padding: '10px 20px', height: '100%' }} className="center_item">
          <TablaDefectivos key={'table_gen'} sample={defectivos}/>
        </Grid>
      </Grid>
      <ModalDefectivo key={'modal_nuevo_def'} open={openNuevo} setOpen={setOpenNuevo} />
    </>
  )
}